import { type MouseEventData } from '../external-types';
import { fabric } from 'fabric';
import { type IPoint } from 'fabric/fabric-impl';
import type Canvas from '../objects/Canvas';
import type UrlInputModalController from '../components/url-input/UrlInputModalController';

/**
 * A brush for selecting objects for the StylusLinkObjectSelection. With minor
 * tweaks this could be used as a generic brush for selecting objects on the
 * whiteboard.
 */
class ObjectSelectionBrush extends fabric.BaseBrush {
  constructor(
    private readonly canvas: Canvas,
    private readonly urlInputModalController: UrlInputModalController
  ) {
    super();
    canvas._isCurrentlyDrawing = true;
    this._render();
  }

  onMouseDown(pointer: IPoint, eventData: MouseEventData) {
    if (!this.canvas._isMainEvent(eventData.e)) {
      return;
    }

    this.canvas.controller.actionSetStylusMenu(null);
  }

  onMouseMove() {
    this.urlInputModalController.actionHoverCurrentTarget();
    this._render();
  }

  onMouseUp() {
    this.urlInputModalController.actionHandleUrlSelectionClick();
    this._render();

    return true;
  }

  cleanupLastRender() {
    this.canvas.clearContext(this.canvas.contextTop);
  }

  _render() {
    this.cleanupLastRender();

    const ctx = this.canvas.contextTop;
    const target = this.urlInputModalController.urlSelectionModalTarget;

    const padding = 3;

    ctx.save();
    ctx.lineWidth = 2;

    if (target) {
      ctx.strokeStyle = '#0073cf'; // aha-blue-500
      const targetRect = target.getBoundingRect();

      ctx.strokeRect(
        targetRect.left - padding,
        targetRect.top - padding,
        targetRect.width + 2 * padding,
        targetRect.height + 2 * padding
      );
    }

    const hoverTarget =
      this.urlInputModalController.urlSelectionModalHoveredObject;

    if (hoverTarget) {
      const hoverRect = hoverTarget.getBoundingRect();
      ctx.strokeStyle = '#96c3ee'; // aha-blue-300
      ctx.strokeRect(
        hoverRect.left - padding,
        hoverRect.top - padding,
        hoverRect.width + 2 * padding,
        hoverRect.height + 2 * padding
      );
    }

    ctx.restore();
  }
}

export default ObjectSelectionBrush;
